<template>
  <v-app>
    <v-data-table
      :page="page"
      :pageCount="numberOfPages"
      :options.sync="options"
      :server-items-length="totalItems"
      :headers="headers"
      :items="items"
      :search="search"
      :loading="loading"
      loading-text="Đang tải dữ liệu... Vui lòng chờ"
      :items-per-page="10"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :footer-props="{
        showFirstLastPage: true
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Quận/Huyện/Thị Xã</v-toolbar-title>
          <v-spacer/>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nhập từ khóa"
            single-line
            hide-details
            clearable
          />
          <v-spacer/>
          <v-btn
            color="primary"
            dark
            class="mb-2"
            v-on:click="showDialog()"
          >
            <v-icon left>mdi-plus</v-icon>
            thêm mới
          </v-btn>
          <Form 
            :showDialog="dialog" 
            :item="item" 
            @confirmed="onConfirmed" 
            @cancelled="onCancelled"
          />
        </v-toolbar>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Tải lại
        </v-btn>
      </template>
    </v-data-table>
  </v-app>
</template>
<script>
  import Form from '@/views/admin/regions/district/Form';
  import { mapState, mapActions } from 'vuex';
  export default {
    components: {
      Form
    },
    data: () => ({
      loading: false,
      dialog: false,
      search: '',
      sortDesc: true,
      sortBy: "name",
      headers: [
        { text: 'Mã đơn vị', value: 'maqh' },
        { text: 'Tên đơn vị', value: 'name' },
        { text: 'Loại', value: 'type' },
        { text: 'Mã Thành Phố', value: 'province.name' }
      ],
      page: 1,
      totalItems: 0,
      numberOfPages: 0,
      items: [],
      editedIndex: -1,
      item: {},
      options: {},
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'thêm mới' : 'cập nhật';
      },
      ...mapState(['system'])
    },
    watch: {
      options: {
        handler() {
          this.initialize();
        },
      },
      search(){
        this.initialize();
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      initialize () {
        const app = this;
        app.loading = true;
        const { page, itemsPerPage, sortBy, sortDesc } = app.options;
        let pageNumber = page;
        let request = {
          params: {
            size: itemsPerPage,
            page: pageNumber,
            keyword: app.search,
            sortDesc: sortDesc[0] ? 'desc' : 'asc',
            sortBy: sortBy[0] ? sortBy[0] : 'name'
          }
        };
        axios.get("api/v1/districts", request)
          .then(response => {
            app.items = response.data.data;
            app.totalItems = response.data.total;
            app.numberOfPages = response.data.to;
            app.loading = false;
          })
          .catch(function (error) {
            app.loading = false;
            app.openSnackbar({ type: 'error' });
          });
      },
      showDialog(item=null){
        this.item = item||{};
        this.dialog = true;
      },
      onConfirmed(item) {
        this.dialog = false;
        this.initialize();
      },
      onCancelled () {
        this.dialog = false;
      },
      editItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialog = true;
      },
      close () {
        this.dialog = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      }
    }
  }
</script>